import React, { useState } from 'react';

const MutualFundCalculator: React.FC = () => {
    const [monthlyInvestment, setMonthlyInvestment] = useState<number>(0);
    const [averageGain, setAverageGain] = useState<number>(0);
    const [years, setYears] = useState<number>(1);
    const [futureValue, setFutureValue] = useState<number | null>(null);

    const calculateFutureValue = () => {
        const months = years * 12;
        const monthlyRate = averageGain / 100 / 12;
        let total = 0;

        for (let i = 0; i < months; i++) {
            total = (total + monthlyInvestment) * (1 + monthlyRate);
        }

        setFutureValue(total);
    };

    return (
        <div className="container">
            <h1>Mutual Fund Calculator</h1>
            <div className="form-group">
                <label>Monthly Investment (₹):</label>
                <input
                    type="number"
                    className="form-control"
                    value={monthlyInvestment}
                    onChange={(e) => setMonthlyInvestment(Number(e.target.value))}
                />
            </div>
            <div className="form-group">
                <label>Average Annual Gain (%):</label>
                <input
                    type="number"
                    className="form-control"
                    value={averageGain}
                    onChange={(e) => setAverageGain(Number(e.target.value))}
                />
            </div>
            <div className="form-group">
                <label>Investment Duration (Years):</label>
                <input
                    type="number"
                    className="form-control"
                    value={years}
                    onChange={(e) => setYears(Number(e.target.value))}
                />
            </div>
            <button className="btn btn-primary mt-3" onClick={calculateFutureValue}>
                Calculate
            </button>
            {futureValue !== null && (
                <div className="mt-4">
                    <h3>Future Value: ₹{futureValue.toFixed(2)}</h3>
                </div>
            )}
        </div>
    );
};
const calculateEMI = (principal: number, annualRate: number, tenureYears: number): number => {
    const monthlyRate = annualRate / 100 / 12;
    const tenureMonths = tenureYears * 12;
    return (
        (principal * monthlyRate * Math.pow(1 + monthlyRate, tenureMonths)) /
        (Math.pow(1 + monthlyRate, tenureMonths) - 1)
    );
};
export default MutualFundCalculator;